export const defaultTDCSTreatmentUnits: { [key: string]: string } = {
  current: 'mA',
  currentDuration: 'min',
};
